<script>
	import { base } from '$app/paths';
	let { cards } = $props();
	let search = $state('');
	let status = $state('all');
	const fold = (value) =>
		value
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase();
	let visible = $derived(
		cards.filter(
			(card) =>
				(status === 'all' || card.status === status) &&
				fold(card.search).includes(fold(search.trim()))
		)
	);
	const statuses = [
		['all', 'All'],
		['supported', 'Supported'],
		['beta', 'Beta'],
		['planned', 'Planned'],
		['deferred', 'Deferred']
	];
</script>

<div class="provider-filter">
	<label for="provider-search"
		>Search providers or formats<input
			id="provider-search"
			type="search"
			bind:value={search}
			placeholder="TaPOS, Spektrix, calendar…"
		/></label
	>
	<label for="provider-status"
		>Support status<select id="provider-status" bind:value={status}
			>{#each statuses as [value, label]}<option {value}
					>{label} ({value === 'all'
						? cards.length
						: cards.filter((card) => card.status === value).length})</option
				>{/each}</select
		></label
	>
</div>
<p aria-live="polite">Showing {visible.length} of {cards.length} entries.</p>
<div class="provider-grid">
	{#each cards as card (card.id)}
		<!-- Keep every anchor in the document, even when a search hides its card. -->
		<div hidden={!visible.includes(card)}>{@html card.html.replaceAll('__APP_BASE__', base)}</div>
	{/each}
</div>
{#if !visible.length}<p>No providers match your search.</p>{/if}
